export default __webpack_public_path__ + "static/media/file-type-pdf-icon.9e9f9c56.svg";